import Pusher from 'pusher-js';
import { API_BASE } from './api-base';

let pusherInstance: Pusher | null = null;
let initPromise: Promise<void> | null = null;

async function init() {
  let key = import.meta.env.VITE_PUSHER_KEY as string;
  let cluster = import.meta.env.VITE_PUSHER_CLUSTER as string;

  if (!key || !cluster) {
    const res = await fetch(`${API_BASE}/api/config`);
    const config = await res.json();
    key = config.pusherKey;
    cluster = config.pusherCluster;
  }

  pusherInstance = new Pusher(key, { cluster });
}

export function ensurePusher(): Promise<void> {
  if (!initPromise) {
    initPromise = init();
  }
  return initPromise;
}

export function getPusher(): Pusher {
  return pusherInstance!;
}
